export default "__VITE_ASSET__438869b9__"